import React, {
  useState,
  useEffect,
  Fragment,
  useMemo,
  useContext,
} from "react";

import "../Scss/ContactStyles.scss?v=1.1.3";
import {
  Box,
  Grid,
  TextField,
  Checkbox,
  FormControl,
  Autocomplete,
  FormLabel,
  LinearProgress,
  Fade,
  Alert,
} from "@mui/material";
import { Button } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import { NavLink, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material/";

import {
  CommonSubHeader,
  getOptionKey,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";
import api from "../../api/axios";
import {
  arrayToStatus,
  showDuplicateContactsSwal,
  usarInformacionContacto,
} from "../../Components/helpers/ContactPlusClient/ContactNClientsHelpers";
import { Dashboard, Save, TableChart } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { PermissionContext } from "../../Components/Context/Context";
import Unauthorized from "../../Components/Common/Design/Unauthorized";

const Crear = () => {
  const navigate = useNavigate();
  const { can } = useContext(PermissionContext);
  const hasPermission = can("contacts", "add");

  const { goPanel, goTable } = useLocationHelpers();
  const Swal = require("sweetalert2");
  const [queryError, setQueryError] = useState(false);
  // OPEN OPTIONS
  const [openOptions, setOpenOptions] = useState({
    assignTo: false,
    lawyer: false,
    provinces: false,
    asociations: false,
    caseTypes: false,
    status: false,
    document_type: false,
  });

  const [options, setOptions] = useState({
    assignTo: [],
    lawyer: [],
    provinces: [],
    asociations: [],
    caseTypes: [],
    status: [],
    document_type: [],
  });

  // Loading Options
  const loadingOptions = Object.keys(openOptions).reduce((acc, key) => {
    acc[key] = openOptions[key] && options[key].length === 0;
    return acc;
  }, {});

  // TAKE VALUES
  const [contactData, setContactData] = useState({
    // ================== LEFT ==================
    company: {
      company_name: "Seleccionar",
      id: 0,
    },

    assignTo: {
      id: 0,
      name: "Seleccionar",
      surname: "",
    },

    lawyer: {
      id: 0,
      name: "Seleccionar",
      surname: "",
    },

    name: "",
    surname: "",
    phone: "",
    email: "",
    address: "",
    postalcode: "",

    province: {
      provincia: "Seleccionar",
      id_provincia: 0,
    },

    document_type: {
      id: 0,
      name: "Seleccionar",
    },

    nif: "",

    // ================== RIGHT ==================
    asociation: {
      id: 0,
      asoc_name: "Seleccionar",
    },

    cases_type: {
      id: 0,
      case_type: "Seleccionar",
    },

    status: {
      id: 0,
      nombre: "Pte Llamada",
    },

    conditions: "",
    title: "",

    // ================== EXTRAS / BACKEND ==================
    observations: "",
    marketing: 0,
    date_in: "",
  });

  const [marketingToShow, setMarketingToShow] = useState("");
  const [marketingToSend, setMarketingToSend] = useState("");
  // ERRORES
  // LABEL CHANGE
  const [valCaseTypeForm, setValCaseTypeForm] = useState("");

  const [flag, setFlag] = useState(false);
  const [userLogged, setUserLogged] = useState(0);
  const [changeOptionsFlag, setChangeOptionsFlag] = useState(false);

  // GET DATA LIST
  const getDataList = async () => {
    setFlag(false);
    const url = `${process.env.REACT_APP_API_URL}/contacts/create`;

    try {
      const response = await api.post(url);
      const data = response.data;
      // console.log(data);

      // Verificar si el token es válido
      const {
        cases_type,
        companies,
        associations,
        lawyers,
        provinces,
        document_types,
        user_logged,
      } = data;

      setUserLogged(user_logged);

      // Actualizar los estados con las listas preparadas
      setOptions({
        companies: [{ company_name: "Seleccionar", id: 0 }, ...companies],
        provinces: [
          { provincia: "Seleccionar", id_provincia: 0 },
          ...provinces,
        ],
        status: arrayToStatus,
        document_type: [{ name: "Seleccionar", id: 0 }, ...document_types],
      });

      setContactData((prevData) => ({
        ...prevData,
        status: { nombre: "Pte Llamada", id: 0 },
      }));

      filterDataByCompany(user_logged.company_id);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setFlag(true);
    }
  };

  const handleContactsFormInformation = async () => {
    const baseUrl = `${process.env.REACT_APP_API_URL}/contacts/search`;

    const queryParams = {
      email: contactData?.email?.trim() || "",
      document: contactData?.nif?.trim() || "",
      phone: contactData?.phone?.trim() || "",
      company_id: contactData?.company?.id || null,
    };

    console.log(contactData);

    let continuarFlujo = true;

    /* =====================================================
     * BUSCAR DUPLICADOS
     * ===================================================== */
    try {
      Swal.fire({
        title: "Buscando coincidencias...",
        text: "Por favor espere un momento",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const { data } = await api.post(baseUrl, queryParams);

      console.log(data);
      Swal.close();

      if (data?.contacts?.length) {
        const contactosUnicos = Array.from(
          new Map(data.contacts.map((c) => [c.id, c])).values(),
        );

        const contactosPreparados = contactosUnicos.map((contacto) => {
          const coincidencias = [];

          if (contacto.email === contactData?.email)
            coincidencias.push("Correo");

          if (contacto.phone === contactData?.phone)
            coincidencias.push("Teléfono");

          if (contacto.nif === contactData?.nif)
            coincidencias.push("Documento");

          return { ...contacto, coincidencias };
        });

        const result = await showDuplicateContactsSwal({
          incomingUser: contactosPreparados,
          flags: data.flag,
          origin: window.location.origin,
          incomingSite: "contactos",
          onUseContact: (contactoSeleccionado) => {
            usarInformacionContacto(
              contactoSeleccionado,
              "contacto",
              null,
              setContactData,
            );
          },
        });

        if (!result.isConfirmed) return;
      }
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al buscar los contactos.",
        icon: "error",
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    /* =====================================================
     * VALIDACIÓN DE CAMPOS
     * ===================================================== */
    const requiredFields = {
      Empresa: contactData?.company?.id,
      "Asignar a": contactData?.assignTo?.id,
      Nombre: contactData?.name,
      Apellido: contactData?.surname,
      Teléfono: contactData?.phone,
      "Tipo de caso": contactData?.cases_type?.id,
    };

    const missingFields = Object.entries(requiredFields).filter(
      ([_, value]) => !value,
    );

    if (missingFields.length) {
      const missingList = missingFields
        .map(([field]) => `<li>${field}</li>`)
        .join("");

      Swal.fire({
        title: '<strong style="color:#f27474">¡Error!</strong>',
        icon: "error",
        html: `Por favor rellene los siguientes campos:<ul style="text-align: left;">${missingList}</ul>`,
        confirmButtonColor: "#1ab394",
      });
      return;
    }

    /* =====================================================
     * CREAR CONTACTO
     * ===================================================== */
    const formattedData = {
      email: contactData?.email?.trim() || "",
      name: contactData?.name?.trim() || "",
      surname: contactData?.surname?.trim() || "",
      postalcode: contactData?.postalcode?.trim() || "",
      nif: contactData?.nif?.trim() || "",
      phone: contactData?.phone?.trim() || "",
      province:
        contactData?.province?.provincia !== "Seleccionar"
          ? contactData?.province?.provincia || ""
          : "",
      condiciones: contactData?.conditions?.replace(/\n/g, "<br />") || "",
      marketing: marketingToSend || 0,
      address: contactData?.address?.trim() || "",
      document_type: contactData?.document_type?.id || 0,
      asociation: contactData?.asociation?.id || 0,
      case_type: contactData?.cases_type?.id || 0,
      status: contactData?.status?.id || 0,
      lawyer: contactData?.lawyer?.id || 0,
      user_id: contactData?.assignTo?.id || 0,
      company_id: contactData?.company?.id || 0,
    };

    const formData = new FormData();
    Object.entries(formattedData).forEach(([k, v]) => formData.append(k, v));

    const confirm = await Swal.fire({
      title: "¿Desea guardar los cambios?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Guardar",
      denyButtonText: "Volver",
      confirmButtonColor: "#1ab394",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    Swal.fire({
      title: "Guardando contacto...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/store`,
        formData,
      );

      Swal.close();

      if (response.data?.error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          html: response.data.error.errorInfo[2],
        });
        return;
      }

      const contactIdCreated = response.data?.contact_create?.id;
      if (!contactIdCreated) return;

      /* =====================================================
       * HISTÓRICO (SE MANTIENE)
       * ===================================================== */
      const historicalData = {
        // notas:
        //   valCaseTypeForm !== ""
        //     ? valCaseTypeForm.replace(/\n/g, "<br />")
        //     : "El contacto se ha registrado de forma correcta",
        title: contactData?.title || "REGISTRO DE CONTACTO",
        case_type: contactData?.cases_type?.id || 0,
        status: contactData?.status?.id || 0,
        lawyer: contactData?.lawyer?.id || 0,
        user_id: contactData?.assignTo?.id || 0,
        created_by: userLogged.id || 0,
        company_id: contactData?.company?.id || 0,
        document: contactData?.nif || "",
        contact_id: contactIdCreated,
        notas: contactData?.observations?.replace(/\n/g, "<br />") || "",
      };

      console.log(historicalData);

      const formDataHistorical = new FormData();
      Object.entries(historicalData).forEach(([k, v]) =>
        formDataHistorical.append(k, v),
      );

      const responseX = await api.post(
        `${process.env.REACT_APP_API_URL}/contacts/create_historical`,
        formDataHistorical,
      );

      console.log(responseX);

      await Swal.fire({
        icon: "success",
        title: "¡Guardado correctamente!",
        timer: 1800,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        navigate(`/contactos/ver?id=${contactIdCreated}`);
      });
    } catch (error) {
      Swal.close();
      console.error(error);
      Swal.fire({
        title: "Error",
        icon: "error",
        text: "No se pudo guardar el contacto.",
      });
    }
  };

  // Función para actualizar valores específicos del contacto
  const updateContactData = (key, value) => {
    setContactData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // SET VARIABLES
  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataList();
  }, []);

  //////////////////// LOW BUTTONS ///////////////////////
  // const caseTypeFunctionChange = (case_id) => {
  //   // console.log("valor1 :" + case_id);
  //   var texto_incapacidad =
  //     "Fecha nacimiento(edad):\nEstado Civil:\nHijos a su cargo:\nSituación Laboral (Funciones que desempeña en su caso):\n¿Alguna Invalidez otorgada o en trámite?:\n¿Cobra dependencia o alguna otra pensión? (En caso afirmativo indicar el tipo de pensión):\n¿Ha presentado recientemente alguna solicitud?\n¿Tiene resolución?\n¿En qué fecha le fue comunicada?";
  //   if (case_id === 9 || case_id === 6 || case_id === 10 || case_id === 11) {
  //     // console.log("valor2 :" + case_id);
  //     setValCaseTypeForm(texto_incapacidad);
  //   }

  //   // $("#notas").html(texto_incapacidad);
  //   // } else {
  //   //   $("#notas").text("");
  // };

  const handleChangeCheckbox = (event) => {
    // console.log(event.target);
    if (event.target.checked == true) {
      setMarketingToSend(1);
      setMarketingToShow(true);
    } else {
      setMarketingToSend(0);
      setMarketingToShow(false);
    }
  };

  const fieldsConfigLeft = useMemo(() => {
    return [
      {
        key: "companyId",
        type: "autocomplete",
        value: contactData?.company || null,
        label: "Empresa",
        className: "companyId",
        open: openOptions.companies,
        options: options.companies,
        loading: loadingOptions.companies,
        onChange: (event, value) => {
          updateContactData(
            "company",
            value
              ? {
                  id: value.id,
                  company_name: value.company_name,
                }
              : null,
          );

          filterDataByCompany(value?.id || 0, true);
        },
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => `${option.company_name}`,
      },
      {
        key: "assignTo",
        type: "autocomplete",
        value: contactData?.assignTo || null,
        disabled: contactData?.company?.id == 0 ? true : false,
        label: "Asignar a",
        className: "assignToId",
        open: openOptions.assignTo,
        options: options.assignTo,
        loading: loadingOptions.assignTo,
        onChange: (event, value) =>
          updateContactData("assignTo", value || null),
        isOptionEqualToValue: (option, value) => option.id === value?.id,
        getOptionLabel: (option) => `${option.name} ${option.surname}`,
      },
      {
        key: "lawyer",
        type: "autocomplete",
        value: contactData?.lawyer || null,
        disabled: contactData?.company?.id == 0 ? true : false,
        label: "Abogado",
        className: "lawyerId",
        open: openOptions.lawyer,
        options: options.lawyer,
        loading: loadingOptions.lawyer,
        onChange: (event, value) => updateContactData("lawyer", value || null),
        isOptionEqualToValue: (option, value) => option?.id === value?.id,
        getOptionLabel: (option) => `${option.name} ${option.surname}`,
      },
      {
        type: "text",
        label: "Nombre",
        value: contactData?.name || "",
        id: "name",
        column: 6,
        onChange: (event) => updateContactData("name", event.target.value),
      },
      {
        type: "text",
        label: "Apellido",
        column: 6,
        value: contactData?.surname || "",
        id: "surname",
        onChange: (event, value) =>
          updateContactData(
            "surname",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Teléfono",
        value: contactData?.phone || "",
        id: "phone",
        inputType: "number",
        onChange: (event, value) =>
          updateContactData(
            "phone",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Email",
        value: contactData?.email || "",
        id: "email",
        onChange: (event, value) =>
          updateContactData(
            "email",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Dirección",
        value: contactData?.address || "",
        id: "address",
        column: 8,
        onChange: (event, value) =>
          updateContactData(
            "address",
            event.target.value != null ? event.target.value : "",
          ),
      },
      {
        type: "text",
        label: "Código postal",
        column: 4,
        value: contactData?.postalcode != null ? contactData?.postalcode : "",
        id: "postalcode",
        onChange: (event) =>
          updateContactData(
            "postalcode",
            event.target.value != null ? event.target.value : "",
          ),
        inputProps: {
          maxLength: 5,
        },
      },
      {
        key: "province",
        value: contactData?.province || null, // Usar una cadena vacía si es null o undefined
        type: "autocomplete",
        label: "Provincia",
        className: "selectWithInput",
        open: openOptions.provinces,
        options: options.provinces,
        loading: loadingOptions.provinces,
        onChange: (event, value) => updateContactData("province", value || ""), // También manejar el valor como cadena vacía
        isOptionEqualToValue: (option, value) =>
          option.provincia === value?.provincia,
        getOptionLabel: (option) => option.provincia,
      },
      {
        key: "document_type",
        value: contactData?.document_type || null, // Usar una cadena vacía si es null o undefined
        type: "autocomplete",
        column: 5,
        label: "Tipo de documento",
        className: "selectWithInput",
        open: openOptions.document_type,
        options: options.document_type,
        loading: loadingOptions.document_type,
        onChange: (event, value) =>
          updateContactData("document_type", value || 0), // También manejar el valor como cadena vacía
        isOptionEqualToValue: (option, value) => option.name === value?.name,
        getOptionLabel: (option) => option.name,
      },
      {
        type: "text",
        column: 7,
        label: "Documento de identidad",
        value: contactData?.nif || "", // Usar una cadena vacía si es null o undefined
        id: "nif",
        onChange: (event, value) =>
          updateContactData("nif", event.target.value || ""), // También manejar el valor como cadena vacía
      },
    ];
  }, [
    changeOptionsFlag,
    contactData, // Si cambian las opciones, también se vuelve a calcular.
  ]);

  const fieldsConfigRight = useMemo(() => {
    const commonFields = [
      {
        key: "asociation",
        value: contactData?.asociation,
        disabled: contactData?.company?.id == 0 ? true : false,
        type: "autocomplete",
        label: "Asociaciones",
        className: "asociationsId",
        open: openOptions.asociations,
        options: options.asociations,
        loading: loadingOptions.asociations,
        onChange: (event, value) => {
          updateContactData("asociation", value || null);
        },
        isOptionEqualToValue: (option, value) =>
          option.asoc_name === value?.asoc_name,
        getOptionLabel: (option) => option.asoc_name,
      },
      {
        key: "caseTypeName",
        type: "autocomplete",
        value: contactData?.cases_type || null,
        disabled: contactData?.company?.id == 0 ? true : false,
        label: "Tipo de caso",
        className: "caseTypeId",
        open: openOptions.caseTypes,
        options: options.caseTypes,
        loading: loadingOptions.caseTypes,
        onChange: (event, value) => {
          updateContactData("cases_type", value || null);
          if (value) {
            // caseTypeFunctionChange(value.id);
            setContactData((prev) => ({
              ...prev,
              observations: value?.case_form || "",
            }));
          }
        },
        isOptionEqualToValue: (option, value) =>
          option.case_type === value?.case_type,
        getOptionLabel: (option) => option.case_type,
      },
      {
        key: "status",
        value: contactData?.status || { nombre: "Pte Llamada", id: 0 },
        type: "autocomplete",
        label: "Estado",
        className: "status",
        open: openOptions.status,
        options: options.status,
        loading: loadingOptions.status,
        onChange: (event, value) => {
          updateContactData("status", value || null);
        },
        isOptionEqualToValue: (option, value) =>
          option.nombre === value?.nombre,
        getOptionLabel: (option) => option.nombre,
      },
      {
        type: "text",
        label: "Condiciones especiales",
        value: contactData?.conditions,
        onChange: (event) =>
          updateContactData("conditions", event.target.value),
      },
      {
        type: "text",
        label: "Titulo observación",
        value: contactData?.title,
        onChange: (event) => updateContactData("title", event.target.value),
      },
      {
        type: "textarea",
        id: "ObservacionesId",
        label: "Observaciones",
        rows: 18,
        value: contactData?.observations,
        onChange: (event) =>
          updateContactData("observations", event.target.value),
      },
    ];

    return commonFields;
  }, [changeOptionsFlag, contactData, valCaseTypeForm]);

  //////////////////// FILTER BY COMPANY  ///////////////////////
  const filterDataByCompany = (company_id, flagFromCompanyInput = false) => {
    if (company_id) {
      try {
        let queryUrl = `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`;

        api.post(queryUrl, { company: company_id }).then((response) => {
          if (response.data) {
            const { cases_types, lawyers, associations } = response.data;

            setOptions((prevData) => ({
              ...prevData,
              assignTo: [{ name: "Seleccionar", surname: "" }, ...lawyers],
              lawyer: [{ name: "Seleccionar", surname: "" }, ...lawyers],
              asociations: [
                { asoc_name: "Seleccionar", id: 0 },
                ...associations,
              ],
              caseTypes: [{ case_type: "Seleccionar", id: 0 }, ...cases_types],
            }));

            if (flagFromCompanyInput == true) {
              const defaultValues = {
                assignTo: { name: "Seleccionar", surname: "" },
                lawyer: { name: "Seleccionar", surname: "" },
                asociation: { asoc_name: "Seleccionar", id: 0 },
                cases_type: { case_type: "Seleccionar", id: 0 },
              };

              Object.entries(defaultValues).forEach(([key, value]) =>
                updateContactData(key, value),
              );
            }

            setChangeOptionsFlag(!changeOptionsFlag);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  //////////////////// SPECIAL BUTTOM ///////////////////////
  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Contactos" subTitle="Crear" />

      {!hasPermission && <Unauthorized />}

      {hasPermission && (
        <Fade timeout={600} in={flag}>
          <Box
            component="form"
            sx={{ margin: "auto", "& > :not(style)": {} }}
            noValidate
            autoComplete="off"
            className="formMainContainer">
            <Alert sx={{ marginBottom: "10px" }} color="info" severity="info">
              <b>NOTA IMPORTANTE:</b>{" "}
              <span>
                Para buscar contactos duplicados, basta con ingresar la empresa
                + el correo, la identificación o el teléfono y presionar
                Guardar.
              </span>
            </Alert>
            <Grid container textAlign="center" className="fontSize">
              {/* ================= LEFT ================= */}
              <Grid
                container
                item
                xs={6}
                spacing={1}
                p="8px"
                sx={{
                  height: "fit-content",
                }}>
                {fieldsConfigLeft.map((field, index) => (
                  <Grid
                    item
                    xs={field.column ?? 12}
                    key={field.key || index}
                    sx={{
                      height: "fit-content",
                    }}>
                    {field.type === "text" ? (
                      <TextField
                        value={field.value}
                        id={field.id}
                        label={field.label}
                        disabled={field.disabled}
                        onChange={field.onChange}
                        type={field.inputType ?? "text"}
                        size="small"
                        variant="outlined"
                        className="inputFormCreate"
                        inputProps={{
                          ...field.inputProps,
                          onInput: (event) => {
                            if (
                              field.id === "postalcode" &&
                              event.target.value.length > 5
                            ) {
                              event.target.value = event.target.value.slice(
                                0,
                                5,
                              );
                            }
                          },
                        }}
                      />
                    ) : field.type === "autocomplete" ? (
                      <FormControl
                        className="inputFormCreate fontSize"
                        fullWidth>
                        <Autocomplete
                          value={field.value || null}
                          disabled={field.disabled}
                          className={field.className}
                          size="small"
                          options={field.options || []}
                          onChange={field.onChange}
                          isOptionEqualToValue={field.isOptionEqualToValue}
                          getOptionLabel={field.getOptionLabel}
                          renderOption={(props, option) => (
                            <li {...props} key={getOptionKey(option)}>
                              {field.getOptionLabel(option)}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {field.loading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    ) : null}
                  </Grid>
                ))}
              </Grid>

              {/* ================= RIGHT ================= */}
              <Grid
                container
                item
                xs={6}
                spacing={1}
                p="8px"
                sx={{
                  height: "fit-content",
                }}>
                {fieldsConfigRight.map((field, index) => (
                  <Grid
                    item
                    xs={field.column ?? 12}
                    sx={{
                      height: "fit-content",
                    }}
                    key={field.key || field.id || index}>
                    {field.type === "autocomplete" ? (
                      <FormControl
                        className="inputFormCreate fontSize"
                        fullWidth>
                        <Autocomplete
                          value={field.value || null}
                          disabled={field.disabled}
                          className={field.className}
                          size="small"
                          options={field.options || []}
                          onChange={field.onChange}
                          isOptionEqualToValue={field.isOptionEqualToValue}
                          getOptionLabel={field.getOptionLabel}
                          renderOption={(props, option) => (
                            <li {...props} key={getOptionKey(option)}>
                              {field.getOptionLabel(option)}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={field.label}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {field.loading && (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    )}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    ) : field.type === "textarea" ? (
                      <FormControl fullWidth>
                        <FormLabel sx={{ textAlign: "left" }}>
                          {field.label}
                        </FormLabel>
                        <textarea
                          rows={field.rows}
                          value={field.value || ""}
                          id="observationsId"
                          onChange={field.onChange}
                          style={{
                            resize: "none",
                            padding: "6px 13px",
                            fontSize: "14px",
                            border: "1px solid rgba(128,128,128,0.35)",
                            borderRadius: "4px",
                            height: "175px",
                          }}
                        />
                      </FormControl>
                    ) : field.type === "text" ? (
                      <TextField
                        id={field.id}
                        label={field.label}
                        value={field.value || ""}
                        onChange={field.onChange}
                        size="small"
                        variant="outlined"
                        className="inputFormCreate fontSize"
                      />
                    ) : null}
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* MARKETING  */}
            <Grid
              sx={{
                boxShadow: "0px 1px 4px 0px gray",
                width: "100%",
              }}
              className="alignItemsAndLeft"
              item
              xs={12}
              p={1}>
              <Checkbox
                checked={
                  marketingToShow == false || marketingToSend == 0
                    ? false
                    : true
                }
                onClick={handleChangeCheckbox}
                inputProps={{ "aria-label": "controlled" }}
                color="success"
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                    width: 28,
                    height: 28,
                  },
                }}
              />
              <span
                style={{
                  fontWeight: "700",
                  textAlign: "left",
                  color: "#676a6c",
                }}>
                Acepto el uso de mi correo electrónico para el envío de
                comunicaciones con fines informativos y comerciales.
              </span>
            </Grid>
            <Grid container item xs={12}>
              <ButtonGroup
                fullWidth
                sx={{
                  mt: 2,
                }}>
                <Button
                  onClick={handleContactsFormInformation}
                  variant="contained"
                  startIcon={<Save />}
                  color="success">
                  Guardar
                </Button>

                <Button
                  component={Link}
                  to="/panel"
                  startIcon={<Dashboard />}
                  variant="outlined">
                  Panel
                </Button>

                <Button
                  component={Link}
                  to="/contactos"
                  startIcon={<TableChart />}
                  variant="outlined"
                  color="error">
                  Tabla contactos
                </Button>
              </ButtonGroup>
            </Grid>
          </Box>
        </Fade>
      )}
    </div>
  );
};

export default Crear;
